export function getFormFieldMissingControlError(): Error {
  return Error('core-form-field must contain a FormFieldControlBaseDirective.');
}

export function getInputUnsupportedTypeError(type: string): Error {
  return Error(`Input type "${type}" isn't supported by coreInput.`);
}
